import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

// Manager components
import FirmManager from '../../pages/audit/manager/FirmManager';
import CaseManager from '../../pages/audit/manager/CaseManager';
import ReportGenerator from '../../pages/audit/manager/ReportGenerator';
import ReviewerManager from '../../pages/audit/manager/ReviewerManager';
import ManagerQuestionManager from '../../pages/audit/manager/QuestionManager';
import ManagerCategoryManager from '../../pages/audit/manager/CategoryManager';
import ManagerQuestionnaireManager from '../../pages/audit/manager/QuestionnaireManager';

// Reviewer components
import ReviewInterface from '../../pages/audit/reviewer/ReviewInterface';

// Client components
import ClientQuestionnaire from '../../pages/audit/client/ClientQuestionnaire';
import ThankYouPage from '../../pages/audit/client/ThankYouPage';

// Shared components
import CaseDetails from '../../pages/audit/shared/CaseDetails';
import MyCases from '../../pages/audit/shared/MyCases';

// Role-based route component
const RoleRoute = ({ element, allowedRoles }) => {
  const { user, isAuthenticated } = useContext(AuthContext);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" />;
  }
  
  return element;
};

const AuditRoutes = () => {
  return (
    <Routes>
      {/* Public routes moved to App.js with ClientLayout */}
      
      {/* Shared routes (all authenticated users) */}
      <Route 
        path="my-cases" 
        element={
          <RoleRoute 
            element={<MyCases />} 
            allowedRoles={['administrator', 'manager', 'reviewer']} 
          />
        } 
      />
      <Route 
        path="cases/:caseId" 
        element={
          <RoleRoute 
            element={<CaseDetails />} 
            allowedRoles={['administrator', 'manager', 'reviewer']} 
          />
        } 
      />
      
      {/* Manager routes */}
      <Route 
        path="firms" 
        element={
          <RoleRoute 
            element={<FirmManager />} 
            allowedRoles={['administrator', 'manager']} 
          />
        } 
      />
      <Route 
        path="cases" 
        element={
          <RoleRoute 
            element={<CaseManager />} 
            allowedRoles={['administrator', 'manager']} 
          />
        } 
      />
      <Route 
        path="cases/:caseId/report" 
        element={
          <RoleRoute 
            element={<ReportGenerator />} 
            allowedRoles={['administrator', 'manager']} 
          />
        } 
      />
      <Route 
        path="reviewers" 
        element={
          <RoleRoute 
            element={<ReviewerManager />} 
            allowedRoles={['administrator', 'manager']} 
          />
        } 
      />
      <Route 
        path="questions" 
        element={
          <RoleRoute 
            element={<ManagerQuestionManager />} 
            allowedRoles={['administrator', 'manager']} 
          />
        } 
      />
      <Route 
        path="categories" 
        element={
          <RoleRoute 
            element={<ManagerCategoryManager />} 
            allowedRoles={['administrator', 'manager']} 
          />
        } 
      />
      <Route 
        path="questionnaires" 
        element={
          <RoleRoute 
            element={<ManagerQuestionnaireManager />} 
            allowedRoles={['administrator', 'manager']} 
          />
        } 
      />
      
      {/* Reviewer routes */}
      <Route 
        path="/cases/:caseId/review" 
        element={
          <RoleRoute 
            element={<ReviewInterface />} 
            allowedRoles={['administrator', 'manager', 'reviewer']} 
          />
        } 
      />
      
      {/* Fallback route */}
      <Route path="*" element={<Navigate to="/my-cases" />} />
    </Routes>
  );
};

export default AuditRoutes;
